/**
 * Client-side E.164 normalization mirroring the server. Superadmin may dial
 * international (+country); everyone else is restricted to US (+1). Returns ""
 * when the number is invalid / not permitted for the role.
 */
export function toE164(raw: string, isSuper: boolean): string {
  const stripped = raw.replace(/[^\d+]/g, "");
  if (stripped.startsWith("+")) {
    if (isSuper) return stripped;
    return /^\+1\d{10}$/.test(stripped) ? stripped : "";
  }
  const digits = stripped.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  if (isSuper && digits.length >= 7) return `+${digits}`;
  return "";
}

export function fmtNumber(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === "1")
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return raw;
}
